import { authFetch } from '../../csrf';
import { API_BASE_URL } from '../../config';

const BASE_URL = `${API_BASE_URL}/crm/customer-payments/kpi`;

/**
 * Validate KPI Uploaded Excel File (Read-Only)
 */
export const validateKpiUpload = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await authFetch(`${BASE_URL}/validate`, {
    method: 'POST',
    credentials: 'include',
    body: formData
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || 'KPI validation failed');
  }

  return data.data;
};

/**
 * Process KPI Updates Execution for a Batch ID
 */
export const processKpiUpload = async (batchId) => {
  const response = await authFetch(`${BASE_URL}/process`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ batchId })
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || 'KPI processing failed');
  }

  return data.data;
};
